import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/loader/styles.scss';export default {
  "loader": "_loader_79cu8_1",
  "item": "_item_79cu8_5",
  "checkbox": "_checkbox_79cu8_15",
  "name": "_name_79cu8_23"
};